export default "__VITE_ASSET__eb118bb3__"